import { render, staticRenderFns } from "./g-selectset.vue?vue&type=template&id=4843f4b1&scoped=true"
import script from "./g-selectset.vue?vue&type=script&lang=js"
export * from "./g-selectset.vue?vue&type=script&lang=js"
import style0 from "./g-selectset.vue?vue&type=style&index=0&id=4843f4b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843f4b1",
  null
  
)

export default component.exports